import React from 'react';

/**
 * StudyDataTable — Tabela compacta de dados associada a um gráfico
 *
 * Props:
 *   data       — Array de objetos (mesmos dados do gráfico)
 *   columns    — Array de { key, label, format?, color?, align? }
 *   caption    — Texto de legenda da tabela (opcional)
 *   maxRows    — Máximo de linhas visíveis (default: all)
 */
const StudyDataTable = ({ data = [], columns = [], caption, maxRows }) => {
  if (!data.length || !columns.length) return null;

  const visibleData = maxRows ? data.slice(0, maxRows) : data;
  const hasMore = maxRows && data.length > maxRows;

  return (
    <div className="border-t border-gray-100 overflow-x-auto">
      {caption && (
        <p className="px-4 pt-3 text-xs text-gray-400 italic">{caption}</p>
      )}
      <table className="w-full text-xs">
        <thead>
          <tr className="bg-gray-50">
            {columns.map((col) => (
              <th
                key={col.key}
                className={`px-4 py-2 font-semibold ${
                  col.align === 'left' ? 'text-left' : 'text-right'
                }`}
                style={{ color: col.color || '#6b7280' }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visibleData.map((row, ri) => (
            <tr key={ri} className="border-t border-gray-50 hover:bg-gray-50">
              {columns.map((col) => {
                const raw = row[col.key];
                const formatted = col.format ? col.format(raw) : raw;
                return (
                  <td
                    key={col.key}
                    className={`px-4 py-1.5 tabular-nums ${
                      col.align === 'left'
                        ? 'text-left font-medium text-gray-700'
                        : 'text-right text-gray-600'
                    }`}
                  >
                    {formatted !== null && formatted !== undefined ? formatted : '—'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {hasMore && (
        <p className="px-4 py-2 text-xs text-gray-400 text-center">
          Mostrando {maxRows} de {data.length} linhas
        </p>
      )}
    </div>
  );
};

export default StudyDataTable;
